import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbLink from './BreadcrumbLink';
import { Flex } from '../Flex';
var propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
};
var Breadcrumbs = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement(Flex, { className: className }, React.Children.map(children, function (child, i) {
        var isLastChild = i === children.length - 1;
        return React.cloneElement(child, { isLastChild: isLastChild });
    })));
};
Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.Link = BreadcrumbLink;
Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = {
    className: '',
};
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map